export interface InputProps {
  field: string
  placeholder: string
  required?: boolean
  email?: boolean
  phone?: boolean
  errorText?: string
  onChange: (field: string, value: string, isValid: boolean) => void
  className?: string
  revalidate: boolean
}

export type InputState = {
  value: string
  isValid: boolean
  touched: boolean
}

export enum ActionTypes {
  INPUT_CHANGE = 'INPUT_CHANGE',
  INPUT_BLUR = 'INPUT_BLUR'
}

type InputChangeType = {
  type: typeof ActionTypes.INPUT_CHANGE
  value: string
  isValid: boolean
}

type InputBlurType = {
  type: typeof ActionTypes.INPUT_BLUR
}

export type InputActionTypes = InputChangeType | InputBlurType
